import { Button } from "@izicvs/ui";
import { t } from "@lingui/macro";
import { Bug, Heart, Lightbulb } from "lucide-react";
import { Link } from "react-router";

import { FeatureCard, PageHero, Section } from "../_components/page-shell";

export const FeedbackPage = () => {
  const channels = [
    {
      icon: Lightbulb,
      title: t`Suggest a feature`,
      description: t`Tell us what would make Izicvs better for your job search.`,
    },
    {
      icon: Bug,
      title: t`Report a bug`,
      description: t`Spotted something off? Let us know so we can fix it fast.`,
    },
    {
      icon: Heart,
      title: t`Share what you love`,
      description: t`Tell us what works well so we can keep building on it.`,
    },
  ];

  return (
    <>
      <PageHero
        eyebrow={t`Suggestions`}
        title={t`Help shape Izicvs`}
        subtitle={t`Your ideas guide what we build next. Share them and help us make Izicvs better.`}
      />

      <Section>
        <p className="mx-auto max-w-2xl text-center text-neutral-600 dark:text-neutral-400">
          {t`Feedback drives our roadmap. Every suggestion, bug report, and kind word helps us decide what to work on next.`}
        </p>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {channels.map((channel, index) => (
            <FeatureCard
              key={channel.title}
              icon={channel.icon}
              title={channel.title}
              description={channel.description}
              index={index}
            />
          ))}
        </div>
      </Section>

      <Section>
        <div className="relative overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent p-10 text-center md:p-14">
          <div className="pointer-events-none absolute -right-16 -top-16 size-48 rounded-full bg-primary/10 blur-3xl" />
          <h2 className="relative mx-auto max-w-2xl text-2xl font-bold text-neutral-800 dark:text-neutral-100 md:text-3xl">
            {t`Ready to share your thoughts?`}
          </h2>
          <p className="relative mx-auto mt-3 max-w-xl text-neutral-600 dark:text-neutral-400">
            {t`Send us an email or reach out through our contact page. We read everything.`}
          </p>
          <div className="relative mt-7 flex flex-wrap items-center justify-center gap-4">
            <Button asChild size="lg">
              <a href="mailto:feedback@izicvs.com">{t`Email your feedback`}</a>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link to="/contact">{t`Contact us`}</Link>
            </Button>
          </div>
        </div>
      </Section>
    </>
  );
};
